
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexK8bypGz9ECrdrIlGjwS4YhfOXZTCbOpuiiCbqYJ_4549AMeta } from "/home/runner/work/pos-admin/pos-admin/pages/index.vue?macro=true";
import { default as signinTc_45znQlSBhVCFAH4oyQSWvKenoNhln3u1qfKA52_45XTQMeta } from "/home/runner/work/pos-admin/pos-admin/pages/signin.vue?macro=true";
import { default as _91uid_93HDDFme7pZi2_45vcz39WBsSgKJz5L0h_TFNcTQ_45o8L_F4Meta } from "/home/runner/work/pos-admin/pos-admin/pages/a/[uid].vue?macro=true";
import { default as new_45PXDy1gv5J3yAElKUx9CY_K3laU2jxkrGbksk7WUxT0Meta } from "/home/runner/work/pos-admin/pos-admin/pages/areas/new.vue?macro=true";
import { default as newB9G_45uI4SWD5dvj4nmBQTtVbG_45378O_45G30y2uOE4pY9EMeta } from "/home/runner/work/pos-admin/pos-admin/pages/modes/new.vue?macro=true";
import { default as newMeE0s8QuJxGGX_OMjKscAPxKU0_JhTlRt6JSfnKft_458Meta } from "/home/runner/work/pos-admin/pos-admin/pages/roles/new.vue?macro=true";
import { default as newO1f9aOIN6ZyD72R3zQ_WDqgKsRs8kSrpzP8kWakn_mEMeta } from "/home/runner/work/pos-admin/pos-admin/pages/shops/new.vue?macro=true";
import { default as indexZwF2sOr51rcac_458JU_45omEOa5dXCZWdvY7nAILrdPPFwMeta } from "/home/runner/work/pos-admin/pos-admin/pages/help/index.vue?macro=true";
import { default as _91id_93fwvjtwxZmRrKXiicnhykYgrqOYMsf5k9fFZA7u5__nUMeta } from "/home/runner/work/pos-admin/pos-admin/pages/modes/[id].vue?macro=true";
import { default as _91id_936MaOZV29dvEztI7M6lNF_tmtP4KFd_Xz9zbVdhW42qEMeta } from "/home/runner/work/pos-admin/pos-admin/pages/roles/[id].vue?macro=true";
import { default as _91uid_935PmmVbguT_TXi0I_YyZFaOkFKepxDUWtWW5G9_Jj2sQMeta } from "/home/runner/work/pos-admin/pos-admin/pages/areas/[uid].vue?macro=true";
import { default as index7T4MX64_8ZHdDLRpTT4X0ASmnmsly1eYOlq7twlkW0cMeta } from "/home/runner/work/pos-admin/pos-admin/pages/areas/index.vue?macro=true";
import { default as newLvokVm4A8CW3E2IvIb9s8UevI5QenyoYM_kQiiAmsTkMeta } from "/home/runner/work/pos-admin/pos-admin/pages/budgets/new.vue?macro=true";
import { default as new51yP0sYGl91VhSGQl7mT2TOKx_wHxnmDWUHtX_457TZD4Meta } from "/home/runner/work/pos-admin/pos-admin/pages/coupons/new.vue?macro=true";
import { default as newdtrFQb69cVVdtA4NFBPR0S0XuIg5Re3c9XFxlah_vPsMeta } from "/home/runner/work/pos-admin/pos-admin/pages/courses/new.vue?macro=true";
import { default as new5Kx3qk8b1dKbw8yPm640qui_0DFtVjRBWTBlZIv9cgAMeta } from "/home/runner/work/pos-admin/pos-admin/pages/devices/new.vue?macro=true";
import { default as indexm9_C_45UO9a2r5a78pOoFer8rdCKU1ttepF6Daj5haYsoMeta } from "/home/runner/work/pos-admin/pos-admin/pages/modes/index.vue?macro=true";
import { default as newpSZ_alaK4F91sLrXRGb6E7LP4FIziReyvpCW8S6OPW0Meta } from "/home/runner/work/pos-admin/pos-admin/pages/outlets/new.vue?macro=true";
import { default as index8KWz36sr_45mb3O80AKvZhrpNArq92SUSUKf1hMyu_45_GwMeta } from "/home/runner/work/pos-admin/pos-admin/pages/roles/index.vue?macro=true";
import { default as _91uid_93tSJKiTRyKQP2LRUlNG_45_gC_ciRWJG1aVQC0_177MXdUMeta } from "/home/runner/work/pos-admin/pos-admin/pages/shops/[uid].vue?macro=true";
import { default as indexOMu0VzScyLgD641BPT3PtEXsAthLr390Q6xQd2P9aFYMeta } from "/home/runner/work/pos-admin/pos-admin/pages/shops/index.vue?macro=true";
import { default as newWK9F1_45Ov5yF01RZksXmWGtoCYAJvEA0ouiighmk0ahMMeta } from "/home/runner/work/pos-admin/pos-admin/pages/payments/new.vue?macro=true";
import { default as new1kylFNsXZ13tAESzY0gmdl3oWjH_45W2TQht6C_PUzbGUMeta } from "/home/runner/work/pos-admin/pos-admin/pages/printers/new.vue?macro=true";
import { default as _91uid_939KW8jC1NrUGB7DL_Q2gLB8wux_yocHmPGTW1DUryA4oMeta } from "/home/runner/work/pos-admin/pos-admin/pages/budgets/[uid].vue?macro=true";
import { default as index71TRZBz4HgvYUQrcgStreB6AlMJf4pCAYKcTE15l6eQMeta } from "/home/runner/work/pos-admin/pos-admin/pages/budgets/index.vue?macro=true";
import { default as _91uid_931LZ0LHe0qPAM8zMsB6ontMKqn_lYj5hJF6xuVx7HL0YMeta } from "/home/runner/work/pos-admin/pos-admin/pages/coupons/[uid].vue?macro=true";
import { default as indexmkOhk_454fsnjHYnDaH_45ddxRFy677saw0EI5g4AYdoRFkMeta } from "/home/runner/work/pos-admin/pos-admin/pages/coupons/index.vue?macro=true";
import { default as _91uid_93fHKGowVBT_45CxUCqNRVfMiGYPYDhfL_45_M1LsFvGUV3x4Meta } from "/home/runner/work/pos-admin/pos-admin/pages/courses/[uid].vue?macro=true";
import { default as indexjIbxcRjqW2Vs3P_45CmzjimZhrnMdqeqm9v2TP0GKtY9sMeta } from "/home/runner/work/pos-admin/pos-admin/pages/courses/index.vue?macro=true";
import { default as _91uid_931_45b_w62rry7q6f7MK3fXMlUnCsK63M3Hr5LZbBCtGfkMeta } from "/home/runner/work/pos-admin/pos-admin/pages/devices/[uid].vue?macro=true";
import { default as indexMOZm2o8_vMiSQZqKy3TeYVSVvp7wHAkiD9gxuktBm9oMeta } from "/home/runner/work/pos-admin/pos-admin/pages/devices/index.vue?macro=true";
import { default as new5TvyjWPtgXyc0Byzl5jmgmdXnbDXzxad4CtwCInhiscMeta } from "/home/runner/work/pos-admin/pos-admin/pages/discounts/new.vue?macro=true";
import { default as newHoBHfavStggP_45QptjuUdWtP6V_454Sda3dbvMTwuQB9z4Meta } from "/home/runner/work/pos-admin/pos-admin/pages/operators/new.vue?macro=true";
import { default as _91uid_93CrUt0URm_sBI9AL0rGetEwkvdVh5g34zA48jDmR9dIEMeta } from "/home/runner/work/pos-admin/pos-admin/pages/outlets/[uid].vue?macro=true";
import { default as indexV0A_451Zu8HZ1LyGSXJjltvtiRh_45k_45MESDtXx4Pf7xVbkMeta } from "/home/runner/work/pos-admin/pos-admin/pages/outlets/index.vue?macro=true";
import { default as index8_451Djh0lYO6TEvHBn4E4G4owXQjxhLfg9IhUHUUWnAwMeta } from "/home/runner/work/pos-admin/pos-admin/pages/reports/index.vue?macro=true";
import { default as _91uid_93M__45Ak6Pfc7EvVB5RWUKihJ_JOur4T8K1Ns9N9lB2RK8Meta } from "/home/runner/work/pos-admin/pos-admin/pages/support/[uid].vue?macro=true";
import { default as indexF4mdn9LY7S16b1uCYPgQg4BCmye69VpYOVYJ60TlqF0Meta } from "/home/runner/work/pos-admin/pos-admin/pages/support/index.vue?macro=true";
import { default as new1YMot6xaUeUd1up09R6ojmdIcTAHZeQvkQGEbA4oljEMeta } from "/home/runner/work/pos-admin/pos-admin/pages/categories/new.vue?macro=true";
import { default as newU2Wbz_lMb7USlxKnRF889Nhhv8U3aArWGJytHy_45pM7EMeta } from "/home/runner/work/pos-admin/pos-admin/pages/condiments/new.vue?macro=true";
import { default as _91_46_46_46slug_93OvXMSZsB3d9JPPOye_457RXv2d4UCvkJhX7t9Y2aQdvUsMeta } from "/home/runner/work/pos-admin/pos-admin/pages/help/[...slug].vue?macro=true";
import { default as indexQB0iX8wjv7IdKplQd_Zi7rX_N7hCQiuT28wuQmWTphgMeta } from "/home/runner/work/pos-admin/pos-admin/pages/invoices/index.vue?macro=true";
import { default as newj8bFazm_sv5PNJGlJ7QUjp9U8uE454qaEptfp3SX4B0Meta } from "/home/runner/work/pos-admin/pos-admin/pages/menu-items/new.vue?macro=true";
import { default as _91uid_93RvDf_cynZE5W5NCIfNUhB615ONhPmz60jNOvy6L17gkMeta } from "/home/runner/work/pos-admin/pos-admin/pages/payments/[uid].vue?macro=true";
import { default as indexP_45KbZs6Kffl1Har6QI9j_454RaZbCbNp68P6zN3U47IQQMeta } from "/home/runner/work/pos-admin/pos-admin/pages/payments/index.vue?macro=true";
import { default as _91uid_93_45Yi_457Qczam4NpcDsTYz2X_cz1OPcvkFPvLEP6IH20EEMeta } from "/home/runner/work/pos-admin/pos-admin/pages/printers/[uid].vue?macro=true";
import { default as indexhDrLSGJ_IUBFxy2jl_45h4G3aiRnDqepBeaCyf7qmVd9IMeta } from "/home/runner/work/pos-admin/pos-admin/pages/printers/index.vue?macro=true";
import { default as _91uid_933IOM78178MreN55U_45J3ZOiN_45Prksz_45fOZDVLuVO7pGcMeta } from "/home/runner/work/pos-admin/pos-admin/pages/receipts/[uid].vue?macro=true";
import { default as indexDV6bop8KZu4kowvZgAYUNSQhv0WW5fFMQCzaXIyPBF8Meta } from "/home/runner/work/pos-admin/pos-admin/pages/receipts/index.vue?macro=true";
import { default as newFN7XCpI19L0u7ykSwlpVhrduQ77x4msvkM4i_45J9N3lEMeta } from "/home/runner/work/pos-admin/pos-admin/pages/table-maps/new.vue?macro=true";
import { default as newLlXJHt0_9_45O0DzCEHWSIQkomQXKdyq_ZJa7teAh7VEwMeta } from "/home/runner/work/pos-admin/pos-admin/pages/admin-roles/new.vue?macro=true";
import { default as newzkW6PGy2Bob1_45Ven77C7i2rUAkB446Cbi39ECqiC61MMeta } from "/home/runner/work/pos-admin/pos-admin/pages/daypartings/new.vue?macro=true";
import { default as _91uid_93SZ0IsJ5_45_45obONFPvXZP72lU1VPxEJMDwmZZh_Mqzk1IMeta } from "/home/runner/work/pos-admin/pos-admin/pages/discounts/[uid].vue?macro=true";
import { default as index_45ra_45Xv_4550rQULvRjZ82uYX6pz6VkNMRHfoUVHSSYPM8Meta } from "/home/runner/work/pos-admin/pos-admin/pages/discounts/index.vue?macro=true";
import { default as indexdJdpwkhhg0_45mosYc9s4_FAQ5HybVGwzoMHuSmf74CnIMeta } from "/home/runner/work/pos-admin/pos-admin/pages/hms-rooms/index.vue?macro=true";
import { default as _91uid_93hg3I9YDv4xrID9nXQoc6xyMcBaSzX4d1Lwoi5FexUHYMeta } from "/home/runner/work/pos-admin/pos-admin/pages/operators/[uid].vue?macro=true";
import { default as index0v5FBcYjOXYd4t_459Qv9uP9lqvjU_45a2qhKCz_459pIT2FMMeta } from "/home/runner/work/pos-admin/pos-admin/pages/operators/index.vue?macro=true";
import { default as _91id_936dWeJbxp0W0p4Yy_DltPRy0p9kIqcO3sHyAPC07JAVEMeta } from "/home/runner/work/pos-admin/pos-admin/pages/properties/[id].vue?macro=true";
import { default as _91uid_93krur4T1uw_4566s9VRIFWjZq_45HoQ8qfDHNoOyDFVKQ9soMeta } from "/home/runner/work/pos-admin/pos-admin/pages/categories/[uid].vue?macro=true";
import { default as indexM0rgTiZkS_iDWN2wyEfJO0LshHZpIE_yhFI2uVME_45zMMeta } from "/home/runner/work/pos-admin/pos-admin/pages/categories/index.vue?macro=true";
import { default as _91uid_933kCGMaf_45LmvG031FTbqLc2_453AVlPZHtSpbZCeQrDXucMeta } from "/home/runner/work/pos-admin/pos-admin/pages/condiments/[uid].vue?macro=true";
import { default as indexA8XetLNO9EsaIQJndpRAzsSrdgiPiINyS4YksxYS1cMMeta } from "/home/runner/work/pos-admin/pos-admin/pages/condiments/index.vue?macro=true";
import { default as _91id_93hdtViA_45FgK2bUgpGL_QkYZIziu2OeZyAtKA_45hDFqlLAMeta } from "/home/runner/work/pos-admin/pos-admin/pages/daypartings/[id].vue?macro=true";
import { default as hmssPLaJq7_TK2WClFaPw6qwa4_45Iamltivh5mXoB7urZvgMeta } from "/home/runner/work/pos-admin/pos-admin/pages/integrations/hms.vue?macro=true";
import { default as _91uid_936ucDF0GCiRhrhKPiu_9ONehf6yO94R7_WVhp_XbAPgMMeta } from "/home/runner/work/pos-admin/pos-admin/pages/menu-items/[uid].vue?macro=true";
import { default as index1u_tMVfcfWZ4DgGJlhw__45L51Vf0fJ5ko6t3t0PPngHIMeta } from "/home/runner/work/pos-admin/pos-admin/pages/menu-items/index.vue?macro=true";
import { default as newIelxb8iUTFaxIbMCevx9R56wciyfvrnYbaz6d45dT_45wMeta } from "/home/runner/work/pos-admin/pos-admin/pages/order-groups/new.vue?macro=true";
import { default as indexd7I5tkpOwrtiOUHOI9MZVQHcR6tFM1yHM4mfyGfK9UwMeta } from "/home/runner/work/pos-admin/pos-admin/pages/properties/index.vue?macro=true";
import { default as _91uid_93_45flVogQBF8CL4ThMEIuYYFR0FKTnz4ASjcIPfjWPOG8Meta } from "/home/runner/work/pos-admin/pos-admin/pages/table-maps/[uid].vue?macro=true";
import { default as indexqcSnw66aY_E7OceUrLy57cXluXbBfvwynH_45CEX8N9DgMeta } from "/home/runner/work/pos-admin/pos-admin/pages/table-maps/index.vue?macro=true";
import { default as _91uid_93OFg5BOkckPj47zPO9qjx9erD0_Y1ClIbnJ_rFecbsJcMeta } from "/home/runner/work/pos-admin/pos-admin/pages/admin-roles/[uid].vue?macro=true";
import { default as indexNymP7oWgt9Dyk3FQj8pUW_0OqJR8x3c6srxTCu_452_45nkMeta } from "/home/runner/work/pos-admin/pos-admin/pages/admin-roles/index.vue?macro=true";
import { default as indexWFqTF30xGtH0rkCp_ep2rDp6it7u_xuIGiWeBMqsCQUMeta } from "/home/runner/work/pos-admin/pos-admin/pages/daypartings/index.vue?macro=true";
import { default as new9NmCfELvTTfZA7tWMLTQ4nQ_Wan2ZdT3_sTUtJh6SH8Meta } from "/home/runner/work/pos-admin/pos-admin/pages/ip-whitelists/new.vue?macro=true";
import { default as new51GDV6Z0em6DiV3tMKkekct6E65tmHu5r_zXjlmgbugMeta } from "/home/runner/work/pos-admin/pos-admin/pages/order-charges/new.vue?macro=true";
import { default as _91id_93lHk5ektv7AKU1p_AWz7cYBdvJgrIKWucZNqXvGe0lkUMeta } from "/home/runner/work/pos-admin/pos-admin/pages/order-groups/[id].vue?macro=true";
import { default as newNBCwLSOaec753NqXwiPigE_9gLkWqMZ67SONj1m5PlgMeta } from "/home/runner/work/pos-admin/pos-admin/pages/order-layouts/new.vue?macro=true";
import { default as indexeFwJ5K0_AltzETH9_k4wiC_E_Sj1Kfoj0822hqAMnd4Meta } from "/home/runner/work/pos-admin/pos-admin/pages/report-void/index.vue?macro=true";
import { default as newITk9CM7g19cqlpgP2ghHMjl8pkrljVmCh8Sn5YgBxAQMeta } from "/home/runner/work/pos-admin/pos-admin/pages/table-charges/new.vue?macro=true";
import { default as indexZ3D4FWYzVacsWX_45lt8OWqx_VCMEDEWBOdMN_16_458wO8Meta } from "/home/runner/work/pos-admin/pos-admin/pages/integrations/index.vue?macro=true";
import { default as _91id_93nZzItu0Orw8MUZ15s_459r547y5esytxAEen6KUv5FesMMeta } from "/home/runner/work/pos-admin/pos-admin/pages/ip-whitelists/[id].vue?macro=true";
import { default as _91id_93SF9HxtNW7YncWafyjGCGpgdpcih8KpZfQtopUD_O1FEMeta } from "/home/runner/work/pos-admin/pos-admin/pages/local-servers/[id].vue?macro=true";
import { default as _91id_93iArYgTklO9q7lJrntbsD3nmi8HkWnxS76mxwV9APWicMeta } from "/home/runner/work/pos-admin/pos-admin/pages/order-charges/[id].vue?macro=true";
import { default as indexWgICI9PlRfMVEOpiR1kL4i0_45C4pLNBZ9KgCI9c3VjRwMeta } from "/home/runner/work/pos-admin/pos-admin/pages/order-groups/index.vue?macro=true";
import { default as _91id_93RDojMU8gr9kHOGSY7kzyHoY2ukM9j5fRjA2Qe83bOKUMeta } from "/home/runner/work/pos-admin/pos-admin/pages/order-layouts/[id].vue?macro=true";
import { default as _91id_93YLOwWtQ8tYl6HfquUiJTS2NQyovErNUBLFQ_45Cr_45dYZEMeta } from "/home/runner/work/pos-admin/pos-admin/pages/organizations/[id].vue?macro=true";
import { default as indexXQjus_45cd7sG81Kace9SV1_45arvlu826IROxuLjcLfXS8Meta } from "/home/runner/work/pos-admin/pos-admin/pages/report-daily/index.vue?macro=true";
import { default as indexjqnDYI5ULzvoAolR576kZ3rf_45paAUc6ZguoVw5G_eykMeta } from "/home/runner/work/pos-admin/pos-admin/pages/report-sales/index.vue?macro=true";
import { default as indexiqHhkKsKoXpqMCqAnEJSLTvke9GrqdH3AIvGgwGfNDYMeta } from "/home/runner/work/pos-admin/pos-admin/pages/report-trend/index.vue?macro=true";
import { default as indexEx_45bulb_45Jxzl_45GE1cJiEYJOxLv_DGJV4bXHrgprnc60Meta } from "/home/runner/work/pos-admin/pos-admin/pages/announcements/index.vue?macro=true";
import { default as square_ElY9rH32wuXRutryyYhkWT94uClrg0qnWE4cYG86p0Meta } from "/home/runner/work/pos-admin/pos-admin/pages/integrations/square.vue?macro=true";
import { default as set_45passwordQysdjfURAWHPdS96_CRlyW2nbbc5ueFHR5rrxPfDDPUMeta } from "/home/runner/work/pos-admin/pos-admin/pages/invite/set-password.vue?macro=true";
import { default as indexA5M9t5gu7R1a8gOoeS78j0K4_NU7AnG1EGz3OdWIiykMeta } from "/home/runner/work/pos-admin/pos-admin/pages/ip-whitelists/index.vue?macro=true";
import { default as index53sKuS2_Ew7XyU7rM5zQYwDSqWLyD3O_4552aofLWMWxcMeta } from "/home/runner/work/pos-admin/pos-admin/pages/local-servers/index.vue?macro=true";
import { default as indexqszTKYtrQz6bl52LSDSuoyFQv_QXnF5vff932bBxELsMeta } from "/home/runner/work/pos-admin/pos-admin/pages/order-charges/index.vue?macro=true";
import { default as indexinh72RxFos_45dS6yR_hryD2vFYL_45zFmHx1PyQBZZ46hgMeta } from "/home/runner/work/pos-admin/pos-admin/pages/order-layouts/index.vue?macro=true";
import { default as index522Wa7dzF5NxpW1MsChH5OTQPQe76wzIZlZyZPY9lqAMeta } from "/home/runner/work/pos-admin/pos-admin/pages/organizations/index.vue?macro=true";
import { default as sentY3qDkRDzMVmi4AQFzZ7Pe3mgdzlqrLmUbXvSyvCwVvkMeta } from "/home/runner/work/pos-admin/pos-admin/pages/password-reset/sent.vue?macro=true";
import { default as neweRDmqdr2IW1NwAwtXMWEhF_45xJUQKawuFOrLkisk0ZJsMeta } from "/home/runner/work/pos-admin/pos-admin/pages/revenue-centers/new.vue?macro=true";
import { default as _91uid_93MrlqI7Z8ZDEUjYJz3gA4JIjUAvLIIlvItGDkSmlXScoMeta } from "/home/runner/work/pos-admin/pos-admin/pages/table-charges/[uid].vue?macro=true";
import { default as indexXEO1MTTFXZYU1e5DUhQ0ZD7pP9W_FfxZGKYBd6CU_45mMMeta } from "/home/runner/work/pos-admin/pos-admin/pages/table-charges/index.vue?macro=true";
import { default as indexMtNTRXhE2gKGKKNLhDADvImIyAVbg47H4_aD0X55iQMMeta } from "/home/runner/work/pos-admin/pos-admin/pages/password-reset/index.vue?macro=true";
import { default as index_454t6q49i53iLOOZi7VRNbJSuTeZ0LMztOq9Y8Ewx4QwMeta } from "/home/runner/work/pos-admin/pos-admin/pages/report-general/index.vue?macro=true";
import { default as indexlZnKoNoV4U5Ehf9DuIv_oEyPlI7Z9CWot_nx9Yy2ZLkMeta } from "/home/runner/work/pos-admin/pos-admin/pages/report-ranking/index.vue?macro=true";
import { default as index5H5qZOV3Ai0ipr1sW2J5sxndEXilGdU4b6fKhOC7TJ8Meta } from "/home/runner/work/pos-admin/pos-admin/pages/report-payments/index.vue?macro=true";
import { default as _91uid_93GUn_45tpyOhvgrbsuscGJiNB1W32jogUox_7e_45Ll_1dGIMeta } from "/home/runner/work/pos-admin/pos-admin/pages/revenue-centers/[uid].vue?macro=true";
import { default as indexTwZB_45rhU5AfzlVMDgmNKpQkw_451u5ckt_450k9i8nicQWIMeta } from "/home/runner/work/pos-admin/pos-admin/pages/revenue-centers/index.vue?macro=true";
import { default as callback0X6CsJhqG8XYXOHS6qltay1GAWf8QpvrRJkyd_aFi3EMeta } from "/home/runner/work/pos-admin/pos-admin/pages/square-oauth/callback.vue?macro=true";
import { default as indexvgtQGd7CjT_Gy4Bw0lQANgrYgAwXAtBLCmz_Pke_45z5sMeta } from "/home/runner/work/pos-admin/pos-admin/pages/admin-audit-logs/index.vue?macro=true";
import { default as index_cYg8EZw0tRnTTinM4sq2jYGYQK_CIKALKIjHboQYRUMeta } from "/home/runner/work/pos-admin/pos-admin/pages/key-arrangements/index.vue?macro=true";
import { default as successUTlOhich53_FzvhWwkq5Zxe949HvZJRWEIWfV071NmgMeta } from "/home/runner/work/pos-admin/pos-admin/pages/password-reset/success.vue?macro=true";
import { default as indexxTbdPRvaZtKe5W__qOoWypaTmrC7SI79Hgp29XtSBmgMeta } from "/home/runner/work/pos-admin/pos-admin/pages/report-customers/index.vue?macro=true";
import { default as indexDAIflrxv0IE_45nQLHlO_2i1Vzq4L_45BpLBOAoFTolpwisMeta } from "/home/runner/work/pos-admin/pos-admin/pages/report-dashboard/index.vue?macro=true";
import { default as indexYoZQt3T_UJxdMFFGNfq2eOgSoTDQRQ0NTYzDsOWLfx0Meta } from "/home/runner/work/pos-admin/pos-admin/pages/report-operators/index.vue?macro=true";
import { default as indexTr9aBXqW9WoiEijGQDtf8_45E6wU_45Z2VDe9A24kHDqoa8Meta } from "/home/runner/work/pos-admin/pos-admin/pages/system-dashboard/index.vue?macro=true";
import { default as indexXoXdQ_45n_45wlqsuz1PjEkDfo7JPDzfT2Ul7BXjyEUKTGsMeta } from "/home/runner/work/pos-admin/pos-admin/pages/report-categories/index.vue?macro=true";
import { default as indexBFOtm_45gZtxK5vCqByAqbNtEvEw5L855vJZQQA6k4L_45cMeta } from "/home/runner/work/pos-admin/pos-admin/pages/report-dayparting/index.vue?macro=true";
import { default as indexgPQYq_CS_45w6PIKkua48WD0rEQgFGzNRFoXTqhI6UNqgMeta } from "/home/runner/work/pos-admin/pos-admin/pages/report-menu-items/index.vue?macro=true";
import { default as indexcl1_45vYy7K22_dwTTQ0Kckiz_45Bqsdl8xeVyh2AgS9HqkMeta } from "/home/runner/work/pos-admin/pos-admin/pages/system-properties/index.vue?macro=true";
import { default as indexKTOEaSCtMP7YL4Njkq0n8K0lI_45xrz8LXD7LDLHCtG1EMeta } from "/home/runner/work/pos-admin/pos-admin/pages/app-configurations/index.vue?macro=true";
import { default as indexf_45tuBTi4Arvag3_rpvNSbt7Z16BQI7GY32PSi0EUWFMMeta } from "/home/runner/work/pos-admin/pos-admin/pages/hms-receipt-imports/index.vue?macro=true";
import { default as indexbG2mf7i_Jg34G4_BcPHOlMgYXlcJu8kBMkM6rmbW7kEMeta } from "/home/runner/work/pos-admin/pos-admin/pages/hms-receipt-payments/index.vue?macro=true";
import { default as new_45password4eJ93TqntJkgHm_OUZwDOjrEv_9LIyIDnA7Vlj208tgMeta } from "/home/runner/work/pos-admin/pos-admin/pages/password-reset/new-password.vue?macro=true";
import { default as newsJ9uCOW45LV_45qejUnoGYuIG4ClrQmNgkA6HJzDyvJskMeta } from "/home/runner/work/pos-admin/pos-admin/pages/table-order-menu-groups/new.vue?macro=true";
import { default as fooding_45journalPEMNC29WifffTkomQpNKBVUo3_KxFkOC6pDHp9nGOxAMeta } from "/home/runner/work/pos-admin/pos-admin/pages/integrations/fooding-journal.vue?macro=true";
import { default as configurations6BOHPKnE0lIUZWKKBLDnf6Y_45wonovW_0gO_k_Vzw06cMeta } from "/home/runner/work/pos-admin/pos-admin/pages/local-servers/configurations.vue?macro=true";
import { default as _91id_93gc8TSdx0N30FKK2RAJSYHaIqzDAsxpvT90a_455s80xQYMeta } from "/home/runner/work/pos-admin/pos-admin/pages/table-order-menu-groups/[id].vue?macro=true";
import { default as _91_91uid_93_93F68q5TT5_45YZxmjJYIXJwX4abVi5hJuGiNzNMDOrwnnMMeta } from "/home/runner/work/pos-admin/pos-admin/pages/announcements/compose/[[uid]].vue?macro=true";
import { default as indextLH5DkPLI6YL0JjZLeoAEsSC_45T3NTxK1xNHmU_45xFTLAMeta } from "/home/runner/work/pos-admin/pos-admin/pages/external-authorizations/index.vue?macro=true";
import { default as indexsBaTDQk_45AIgnMahjq6Lqphlt2HZzSrGcu8jD3bwLYU0Meta } from "/home/runner/work/pos-admin/pos-admin/pages/table-order-menu-groups/index.vue?macro=true";
import { default as newH8USYPh9UM8JKq7HBLEnD0jYQTC5Qaxq9KKZJwTxRmoMeta } from "/home/runner/work/pos-admin/pos-admin/pages/table-order-menu-subgroups/new.vue?macro=true";
import { default as newcz2mjC4R5_79aY9TZfiYew7fEeq6OzbDmmIhQ_45pag_45kMeta } from "/home/runner/work/pos-admin/pos-admin/pages/table-order-topping-groups/new.vue?macro=true";
import { default as _91id_93_45ASv5CBZ1ZHJhZoXNITtnb_jmpcM9FdP_pJfZKnXOdQMeta } from "/home/runner/work/pos-admin/pos-admin/pages/table-order-menu-subgroups/[id].vue?macro=true";
import { default as _91id_93lb9DhF1SvnfeC8R7jqTu49gaIzGYAb_yUOlzLdypP1sMeta } from "/home/runner/work/pos-admin/pos-admin/pages/table-order-topping-groups/[id].vue?macro=true";
import { default as indexT_vzmI9_45aiD5GgeQYg40MT_45hrZWvsObAm8ZoS1lG9IEMeta } from "/home/runner/work/pos-admin/pos-admin/pages/table-order-view-settings/index.vue?macro=true";
import { default as indexfgSx8wxrFlzcuyPcIcrVZGLnujrBn3qzn8ci_45f_45HJDcMeta } from "/home/runner/work/pos-admin/pos-admin/pages/table-order-menu-subgroups/index.vue?macro=true";
import { default as indexSfbLZmXJBBn5a5gvWs6QRxZ7eQP8by02YNl6fhCfHwwMeta } from "/home/runner/work/pos-admin/pos-admin/pages/table-order-topping-groups/index.vue?macro=true";
import { default as newlxmTFcGBsmMSygwtATJznX5SDwjuTiuKrHMIMDHOm34Meta } from "/home/runner/work/pos-admin/pos-admin/pages/table-order-table-configurations/new.vue?macro=true";
import { default as _91id_93ot0lW_zqTEKR2Xpjka7YcEidHeLnfwAe0okRazomw0YMeta } from "/home/runner/work/pos-admin/pos-admin/pages/table-order-table-configurations/[id].vue?macro=true";
import { default as indexYCuSisl_hVbevug73xia0Bfr_INpoRWKbnw2_2d2sksMeta } from "/home/runner/work/pos-admin/pos-admin/pages/table-order-table-configurations/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/index.vue")
  },
  {
    name: "signin",
    path: "/signin",
    meta: signinTc_45znQlSBhVCFAH4oyQSWvKenoNhln3u1qfKA52_45XTQMeta || {},
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/signin.vue")
  },
  {
    name: "a-uid",
    path: "/a/:uid()",
    meta: _91uid_93HDDFme7pZi2_45vcz39WBsSgKJz5L0h_TFNcTQ_45o8L_F4Meta || {},
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/a/[uid].vue")
  },
  {
    name: "areas-new",
    path: "/areas/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/areas/new.vue")
  },
  {
    name: "modes-new",
    path: "/modes/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/modes/new.vue")
  },
  {
    name: "roles-new",
    path: "/roles/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/roles/new.vue")
  },
  {
    name: "shops-new",
    path: "/shops/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/shops/new.vue")
  },
  {
    name: "help",
    path: "/help",
    meta: { ...(indexZwF2sOr51rcac_458JU_45omEOa5dXCZWdvY7nAILrdPPFwMeta || {}), ...{"middleware":"help-index-redirect"} },
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/help/index.vue")
  },
  {
    name: "modes-id",
    path: "/modes/:id()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/modes/[id].vue")
  },
  {
    name: "roles-id",
    path: "/roles/:id()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/roles/[id].vue")
  },
  {
    name: "areas-uid",
    path: "/areas/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/areas/[uid].vue")
  },
  {
    name: "areas",
    path: "/areas",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/areas/index.vue")
  },
  {
    name: "budgets-new",
    path: "/budgets/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/budgets/new.vue")
  },
  {
    name: "coupons-new",
    path: "/coupons/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/coupons/new.vue")
  },
  {
    name: "courses-new",
    path: "/courses/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/courses/new.vue")
  },
  {
    name: "devices-new",
    path: "/devices/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/devices/new.vue")
  },
  {
    name: "modes",
    path: "/modes",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/modes/index.vue")
  },
  {
    name: "outlets-new",
    path: "/outlets/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/outlets/new.vue")
  },
  {
    name: "roles",
    path: "/roles",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/roles/index.vue")
  },
  {
    name: "shops-uid",
    path: "/shops/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/shops/[uid].vue")
  },
  {
    name: "shops",
    path: "/shops",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/shops/index.vue")
  },
  {
    name: "payments-new",
    path: "/payments/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/payments/new.vue")
  },
  {
    name: "printers-new",
    path: "/printers/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/printers/new.vue")
  },
  {
    name: "budgets-uid",
    path: "/budgets/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/budgets/[uid].vue")
  },
  {
    name: "budgets",
    path: "/budgets",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/budgets/index.vue")
  },
  {
    name: "coupons-uid",
    path: "/coupons/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/coupons/[uid].vue")
  },
  {
    name: "coupons",
    path: "/coupons",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/coupons/index.vue")
  },
  {
    name: "courses-uid",
    path: "/courses/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/courses/[uid].vue")
  },
  {
    name: "courses",
    path: "/courses",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/courses/index.vue")
  },
  {
    name: "devices-uid",
    path: "/devices/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/devices/[uid].vue")
  },
  {
    name: "devices",
    path: "/devices",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/devices/index.vue")
  },
  {
    name: "discounts-new",
    path: "/discounts/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/discounts/new.vue")
  },
  {
    name: "operators-new",
    path: "/operators/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/operators/new.vue")
  },
  {
    name: "outlets-uid",
    path: "/outlets/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/outlets/[uid].vue")
  },
  {
    name: "outlets",
    path: "/outlets",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/outlets/index.vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/reports/index.vue")
  },
  {
    name: "support-uid",
    path: "/support/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/support/[uid].vue")
  },
  {
    name: "support",
    path: "/support",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/support/index.vue")
  },
  {
    name: "categories-new",
    path: "/categories/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/categories/new.vue")
  },
  {
    name: "condiments-new",
    path: "/condiments/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/condiments/new.vue")
  },
  {
    name: "help-slug",
    path: "/help/:slug(.*)*",
    meta: _91_46_46_46slug_93OvXMSZsB3d9JPPOye_457RXv2d4UCvkJhX7t9Y2aQdvUsMeta || {},
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/help/[...slug].vue")
  },
  {
    name: "invoices",
    path: "/invoices",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/invoices/index.vue")
  },
  {
    name: "menu-items-new",
    path: "/menu-items/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/menu-items/new.vue")
  },
  {
    name: "payments-uid",
    path: "/payments/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/payments/[uid].vue")
  },
  {
    name: "payments",
    path: "/payments",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/payments/index.vue")
  },
  {
    name: "printers-uid",
    path: "/printers/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/printers/[uid].vue")
  },
  {
    name: "printers",
    path: "/printers",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/printers/index.vue")
  },
  {
    name: "receipts-uid",
    path: "/receipts/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/receipts/[uid].vue")
  },
  {
    name: "receipts",
    path: "/receipts",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/receipts/index.vue")
  },
  {
    name: "table-maps-new",
    path: "/table-maps/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-maps/new.vue")
  },
  {
    name: "admin-roles-new",
    path: "/admin-roles/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/admin-roles/new.vue")
  },
  {
    name: "daypartings-new",
    path: "/daypartings/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/daypartings/new.vue")
  },
  {
    name: "discounts-uid",
    path: "/discounts/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/discounts/[uid].vue")
  },
  {
    name: "discounts",
    path: "/discounts",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/discounts/index.vue")
  },
  {
    name: "hms-rooms",
    path: "/hms-rooms",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/hms-rooms/index.vue")
  },
  {
    name: "operators-uid",
    path: "/operators/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/operators/[uid].vue")
  },
  {
    name: "operators",
    path: "/operators",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/operators/index.vue")
  },
  {
    name: "properties-id",
    path: "/properties/:id()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/properties/[id].vue")
  },
  {
    name: "categories-uid",
    path: "/categories/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/categories/[uid].vue")
  },
  {
    name: "categories",
    path: "/categories",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/categories/index.vue")
  },
  {
    name: "condiments-uid",
    path: "/condiments/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/condiments/[uid].vue")
  },
  {
    name: "condiments",
    path: "/condiments",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/condiments/index.vue")
  },
  {
    name: "daypartings-id",
    path: "/daypartings/:id()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/daypartings/[id].vue")
  },
  {
    name: "integrations-hms",
    path: "/integrations/hms",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/integrations/hms.vue")
  },
  {
    name: "menu-items-uid",
    path: "/menu-items/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/menu-items/[uid].vue")
  },
  {
    name: "menu-items",
    path: "/menu-items",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/menu-items/index.vue")
  },
  {
    name: "order-groups-new",
    path: "/order-groups/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/order-groups/new.vue")
  },
  {
    name: "properties",
    path: "/properties",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/properties/index.vue")
  },
  {
    name: "table-maps-uid",
    path: "/table-maps/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-maps/[uid].vue")
  },
  {
    name: "table-maps",
    path: "/table-maps",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-maps/index.vue")
  },
  {
    name: "admin-roles-uid",
    path: "/admin-roles/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/admin-roles/[uid].vue")
  },
  {
    name: "admin-roles",
    path: "/admin-roles",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/admin-roles/index.vue")
  },
  {
    name: "daypartings",
    path: "/daypartings",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/daypartings/index.vue")
  },
  {
    name: "ip-whitelists-new",
    path: "/ip-whitelists/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/ip-whitelists/new.vue")
  },
  {
    name: "order-charges-new",
    path: "/order-charges/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/order-charges/new.vue")
  },
  {
    name: "order-groups-id",
    path: "/order-groups/:id()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/order-groups/[id].vue")
  },
  {
    name: "order-layouts-new",
    path: "/order-layouts/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/order-layouts/new.vue")
  },
  {
    name: "report-void",
    path: "/report-void",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/report-void/index.vue")
  },
  {
    name: "table-charges-new",
    path: "/table-charges/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-charges/new.vue")
  },
  {
    name: "integrations",
    path: "/integrations",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/integrations/index.vue")
  },
  {
    name: "ip-whitelists-id",
    path: "/ip-whitelists/:id()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/ip-whitelists/[id].vue")
  },
  {
    name: "local-servers-id",
    path: "/local-servers/:id()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/local-servers/[id].vue")
  },
  {
    name: "order-charges-id",
    path: "/order-charges/:id()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/order-charges/[id].vue")
  },
  {
    name: "order-groups",
    path: "/order-groups",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/order-groups/index.vue")
  },
  {
    name: "order-layouts-id",
    path: "/order-layouts/:id()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/order-layouts/[id].vue")
  },
  {
    name: "organizations-id",
    path: "/organizations/:id()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/organizations/[id].vue")
  },
  {
    name: "report-daily",
    path: "/report-daily",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/report-daily/index.vue")
  },
  {
    name: "report-sales",
    path: "/report-sales",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/report-sales/index.vue")
  },
  {
    name: "report-trend",
    path: "/report-trend",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/report-trend/index.vue")
  },
  {
    name: "announcements",
    path: "/announcements",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/announcements/index.vue")
  },
  {
    name: "integrations-square",
    path: "/integrations/square",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/integrations/square.vue")
  },
  {
    name: "invite-set-password",
    path: "/invite/set-password",
    meta: set_45passwordQysdjfURAWHPdS96_CRlyW2nbbc5ueFHR5rrxPfDDPUMeta || {},
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/invite/set-password.vue")
  },
  {
    name: "ip-whitelists",
    path: "/ip-whitelists",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/ip-whitelists/index.vue")
  },
  {
    name: "local-servers",
    path: "/local-servers",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/local-servers/index.vue")
  },
  {
    name: "order-charges",
    path: "/order-charges",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/order-charges/index.vue")
  },
  {
    name: "order-layouts",
    path: "/order-layouts",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/order-layouts/index.vue")
  },
  {
    name: "organizations",
    path: "/organizations",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/organizations/index.vue")
  },
  {
    name: "password-reset-sent",
    path: "/password-reset/sent",
    meta: sentY3qDkRDzMVmi4AQFzZ7Pe3mgdzlqrLmUbXvSyvCwVvkMeta || {},
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/password-reset/sent.vue")
  },
  {
    name: "revenue-centers-new",
    path: "/revenue-centers/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/revenue-centers/new.vue")
  },
  {
    name: "table-charges-uid",
    path: "/table-charges/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-charges/[uid].vue")
  },
  {
    name: "table-charges",
    path: "/table-charges",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-charges/index.vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexMtNTRXhE2gKGKKNLhDADvImIyAVbg47H4_aD0X55iQMMeta || {},
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/password-reset/index.vue")
  },
  {
    name: "report-general",
    path: "/report-general",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/report-general/index.vue")
  },
  {
    name: "report-ranking",
    path: "/report-ranking",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/report-ranking/index.vue")
  },
  {
    name: "report-payments",
    path: "/report-payments",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/report-payments/index.vue")
  },
  {
    name: "revenue-centers-uid",
    path: "/revenue-centers/:uid()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/revenue-centers/[uid].vue")
  },
  {
    name: "revenue-centers",
    path: "/revenue-centers",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/revenue-centers/index.vue")
  },
  {
    name: "square-oauth-callback",
    path: "/square-oauth/callback",
    meta: callback0X6CsJhqG8XYXOHS6qltay1GAWf8QpvrRJkyd_aFi3EMeta || {},
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/square-oauth/callback.vue")
  },
  {
    name: "admin-audit-logs",
    path: "/admin-audit-logs",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/admin-audit-logs/index.vue")
  },
  {
    name: "key-arrangements",
    path: "/key-arrangements",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/key-arrangements/index.vue")
  },
  {
    name: "password-reset-success",
    path: "/password-reset/success",
    meta: successUTlOhich53_FzvhWwkq5Zxe949HvZJRWEIWfV071NmgMeta || {},
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/password-reset/success.vue")
  },
  {
    name: "report-customers",
    path: "/report-customers",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/report-customers/index.vue")
  },
  {
    name: "report-dashboard",
    path: "/report-dashboard",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/report-dashboard/index.vue")
  },
  {
    name: "report-operators",
    path: "/report-operators",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/report-operators/index.vue")
  },
  {
    name: "system-dashboard",
    path: "/system-dashboard",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/system-dashboard/index.vue")
  },
  {
    name: "report-categories",
    path: "/report-categories",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/report-categories/index.vue")
  },
  {
    name: "report-dayparting",
    path: "/report-dayparting",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/report-dayparting/index.vue")
  },
  {
    name: "report-menu-items",
    path: "/report-menu-items",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/report-menu-items/index.vue")
  },
  {
    name: "system-properties",
    path: "/system-properties",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/system-properties/index.vue")
  },
  {
    name: "app-configurations",
    path: "/app-configurations",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/app-configurations/index.vue")
  },
  {
    name: "hms-receipt-imports",
    path: "/hms-receipt-imports",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/hms-receipt-imports/index.vue")
  },
  {
    name: "hms-receipt-payments",
    path: "/hms-receipt-payments",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/hms-receipt-payments/index.vue")
  },
  {
    name: "password-reset-new-password",
    path: "/password-reset/new-password",
    meta: new_45password4eJ93TqntJkgHm_OUZwDOjrEv_9LIyIDnA7Vlj208tgMeta || {},
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/password-reset/new-password.vue")
  },
  {
    name: "table-order-menu-groups-new",
    path: "/table-order-menu-groups/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-order-menu-groups/new.vue")
  },
  {
    name: "integrations-fooding-journal",
    path: "/integrations/fooding-journal",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/integrations/fooding-journal.vue")
  },
  {
    name: "local-servers-configurations",
    path: "/local-servers/configurations",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/local-servers/configurations.vue")
  },
  {
    name: "table-order-menu-groups-id",
    path: "/table-order-menu-groups/:id()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-order-menu-groups/[id].vue")
  },
  {
    name: "announcements-compose-uid",
    path: "/announcements/compose/:uid?",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/announcements/compose/[[uid]].vue")
  },
  {
    name: "external-authorizations",
    path: "/external-authorizations",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/external-authorizations/index.vue")
  },
  {
    name: "table-order-menu-groups",
    path: "/table-order-menu-groups",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-order-menu-groups/index.vue")
  },
  {
    name: "table-order-menu-subgroups-new",
    path: "/table-order-menu-subgroups/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-order-menu-subgroups/new.vue")
  },
  {
    name: "table-order-topping-groups-new",
    path: "/table-order-topping-groups/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-order-topping-groups/new.vue")
  },
  {
    name: "table-order-menu-subgroups-id",
    path: "/table-order-menu-subgroups/:id()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-order-menu-subgroups/[id].vue")
  },
  {
    name: "table-order-topping-groups-id",
    path: "/table-order-topping-groups/:id()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-order-topping-groups/[id].vue")
  },
  {
    name: "table-order-view-settings",
    path: "/table-order-view-settings",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-order-view-settings/index.vue")
  },
  {
    name: "table-order-menu-subgroups",
    path: "/table-order-menu-subgroups",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-order-menu-subgroups/index.vue")
  },
  {
    name: "table-order-topping-groups",
    path: "/table-order-topping-groups",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-order-topping-groups/index.vue")
  },
  {
    name: "table-order-table-configurations-new",
    path: "/table-order-table-configurations/new",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-order-table-configurations/new.vue")
  },
  {
    name: "table-order-table-configurations-id",
    path: "/table-order-table-configurations/:id()",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-order-table-configurations/[id].vue")
  },
  {
    name: "table-order-table-configurations",
    path: "/table-order-table-configurations",
    component: () => import("/home/runner/work/pos-admin/pos-admin/pages/table-order-table-configurations/index.vue")
  }
]